<div class="app-content content">
    <div class="content-wrapper">
        <div class="content-header row mb-1">
            <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
        </div>
        <ng-container mCardHeaderTitle>
            <ng-template #modalContent let-close="close">


                <form #f1="ngForm" (keydown.enter)="$event.preventDefault()" (ngSubmit)="SaveCustomer(f1.form.valid)">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ model.action }}</h5>
                        <button type="button" class="close" (click)="close()">
              <span aria-hidden="true">&times;</span>
            </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-body">
                            <div class="form-group">
                                <input type="hidden" id="idCustomer" name="idCustomer" [(ngModel)]="model.idCustomer" value=0 #idCustomer="ngModel">
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="firstName">Full Name *</label>
                                        <input type="text" id="customerFirstName" class="form-control border-primary" placeholder="Full Name" [(ngModel)]="model.customerFirstName" name="customerFirstName" #customerFirstName="ngModel" required>
                                        <small class="form-text text-muted danger" *ngIf="!customerFirstName.valid && f1.submitted">First
                      Name is required.</small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">GST No </label>
                                        <input type="text" id="customerGSTNO" class="form-control border-primary" placeholder="GST No" [(ngModel)]="model.customerGSTNO" name="customerGSTNO" #customerGSTNO="ngModel">

                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">Email Id</label>
                                        <input type="email" id="customerEmail" class="form-control border-primary" placeholder="Email Id" [(ngModel)]="model.customerEmail" name="customerEmail" #customerEmail="ngModel">

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">Contact No </label>
                                        <input type="text" id="customerContact" class="form-control border-primary" placeholder="Contact No" [(ngModel)]="model.customerContact" name="customerContact" #customerContact="ngModel">

                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">Address </label>
                                        <input type="text" id="customerAddress" class="form-control border-primary" placeholder="Address" [(ngModel)]="model.customerAddress" name="customerAddress" #customerAddress="ngModel">

                                    </div>
                                </div>



                            </div>


                        </div>


                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-outline-secondary">Save</button>
                    </div>
                </form>

            </ng-template>

        </ng-container>
        <div class="content-body">
            <!-- <ngx-spinner bdColor = "rgba(0,0,0,0.5)" size = "medium" color = "#fff" type = "line-spin-fade" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner> -->
            <app-custom-loader-c></app-custom-loader-c>


            <section id="drag-area">

                <div class="row">
                    <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
                        <m-card [options]="options" (reloadFunction)="reloadProjectInfo($event)">

                            <ng-container mCardBody>

                                <form #f="ngForm" (keydown.enter)="$event.stopPropagation()" (ngSubmit)="$event.stopPropagation()">

                                    <div class="form-body">


                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="firstName">Select Customer  *</label>
                                                    <ng-select [items]="customerarray" style=" border: 1px solid #666ee8" [searchable]="true" bindLabel="customerFullName" id="selectcustomer" placeholder="Select Customer Name" [virtualScroll]="true" [(ngModel)]="model.selectcustomer" (change)="bindformcustomer(model.selectcustomer)"
                                                        name="selectcustomer" #selectcustomer="ngModel" required>
                                                    </ng-select>
                                                    <small class="form-text text-muted danger" *ngIf="!selectcustomer.valid && f.submitted">Please
                            select Customer .</small>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <a (keydown.enter)="$event.preventDefault()" (click)="addcustomer()" class="btn btn-primary btn-sm gap_contact" style="margin-top: 6%;color:aliceblue">
                                                        <i class="d-md-none d-block feather ft-plus white"></i><span class="d-md-block d-none">Add
                            Customer</span></a>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="firstName"></label>

                                                </div>
                                            </div>

                                        </div>



                                        <ng-container *ngIf="showcustomer">
                                            <div class="form-actions text-right">
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="div-custom-header" for="PatientInformation">Customer Information </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="FirstName">Full Name :</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="FirstName">{{customermodel.customerFirstName}}</label>
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="DOB">GST No:</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="DOB">{{customermodel.customerGSTNO}}</label>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="EmailId"><b>Email Id :</b></label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="EmailId">{{customermodel.customerEmail}}</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="Gender">Contact No:</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="Gender">{{customermodel.customerContact}}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="ContactNo">Address:</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <p>{{customermodel.customerAddress}}</p>
                                                    </div>
                                                </div>

                                            </div>


                                            <div class="form-actions text-right">
                                            </div>
                                            <ng-container>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="div-custom-header" for="ChallanItems"><b>Challan</b></label>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label for="challanDate"> Date *</label>
                                                            <input type="date" class="form-control border-primary" [(ngModel)]="model.challanDate" name="challanDate" #challanDate="ngModel" [max]="maxdate" required />
                                                            <small class="form-text text-muted danger" *ngIf="!challanDate.valid && f.submitted">Please
                                challan Date .</small>



                                                        </div>
                                                    </div>
                                                </div>



                                                <div class="form-actions text-right">
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="div-custom-header" for="ChallanItems"><b> Items</b></label>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-3" style="padding-left: 1.5%;">
                                                        <div class="form-group">
                                                            <label for="challanItemQrCode" style="text-align: center;">Barcode *</label>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-2" style="padding-left: 1.5%;">
                                                        <div class="form-group">
                                                            <label for="challanItemNameDes">Sr. No.</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3" style="padding-left: 1.5%;">
                                                        <div class="form-group">
                                                            <label for="challanItemNameDes">Description *</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2" style="padding-left: 1.5%;">
                                                        <div class="form-group">
                                                            <label for="challanItemQty">Qty</label>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div *ngFor="let obj of challanItems; let i=index">
                                                    <div *ngIf="obj.operationState !='d'" class="row">
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <input type="text" class="form-control border-primary" (keypress)="updateOperationState(i);" (keyup.enter)="onScan(i)" (keydown.tab)="onScan(i)" [(ngModel)]="challanItems[i].challanItemQrCode" (keydown)="$event.keyCode == 13 ? $event.preventDefault() : null"
                                                                    placeholder="Barcode " name="challanItemQrCode{{i}}" #challanItemQrCode="ngModel" required>
                                                                <small class="form-text text-muted danger" *ngIf="challanItems[i].challanItemQrCode==undefined && f.submitted">Please Scan
                                  Barcode.</small>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div class="form-group">
                                                                <input type="text" class="form-control border-primary" disabled [(ngModel)]="challanItems[i].challanItemSerialNo" placeholder="Serial Number" (keypress)="updateOperationState(i);" name="challanItemSerialNo{{i}}" #challanItemSerialNo="ngModel">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <input type="text" class="form-control border-primary" (keypress)="updateOperationState(i);" [(ngModel)]="challanItems[i].challanItemNameDes" placeholder="Description" (keypress)="updateOperationState(i);" name="challanItemNameDes{{i}}" #challanItemNameDes="ngModel"
                                                                    required>
                                                                <small class="form-text text-muted danger" *ngIf="challanItems[i].challanItemNameDes==undefined && f.submitted">
                                  Description
                                  </small>

                                                            </div>
                                                        </div>

                                                        <div class="col-md-2">
                                                            <div class="form-group">
                                                                <input type="number" class="form-control border-primary" (keypress)="updateOperationState(i);" [(ngModel)]="challanItems[i].challanItemQty" placeholder="Qty" min=1 readonly name="challanItemQty{{i}}" #challanItemQty="ngModel">

                                                            </div>
                                                        </div>



                                                        <div class="col-md-1">
                                                            <div class="zommin form-group">

                                                                <a class="danger delete ">
                                                                    <i (click)="RemoveForm(i)" style="padding: 10%; font-size: 1.9rem;" class="la la-trash-o"></i>
                                                                </a>
                                                            </div>



                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-2">

                                                    </div>
                                                    <div class="col-md-3">

                                                    </div>
                                                    <div class="col-md-2">

                                                    </div>
                                                    <div class="col-md-2">

                                                    </div>
                                                    <div class="col-md-2">

                                                    </div>

                                                    <div class="col-md-1">
                                                        <div class="zommin form-group">
                                                            <a>

                                                                <img (click)="AddForm()" style="    padding-left: 10%;
                                  margin-top: -44%;" src="../../../../../assets/images/icons/plusicon.png">

                                                            </a>

                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="form-actions " style="margin-top: 40px;">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="challanContactNo">Enquiry Number </label>
                                                                <input type="text" class="form-control border-primary" [(ngModel)]="model.challanContactNo" name="challanContactNo" #challanContactNo="ngModel" />

                                                            </div>
                                                        </div>





                                                    </div>


                                                </div>
                                                <div class="form-actions text-right">

                                                    <button type="button" (click)="cancel()" class="btn btn-warning mr-1">
                            <i class="feather ft-x"></i> Cancel
                          </button>
                                                    <button type="submit" (keydown.enter)="$event.stopPropagation()" (click)="savechallan(f.form.valid)" class="btn btn-primary">
                            <i class="la la-check"></i> Save
                          </button>

                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </form>
                            </ng-container>
                        </m-card>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>